module.exports = __webpack_public_path__ + "img/camera-video.d35f8e7f.svg";